
<template>
  <div class="all-regiv">
    <div class="rg-btbg">
      <div class="register">
        <div class="rg-herder disFlex center" style="flex-direction: column;">
          <div style="font-size: 28px;">新用户注册</div>
          <div style="color: #9a9a9a;font-size: 14px;padding-top: 7px;">REDISTERED ACCOUNT</div>
        </div>
        <div class="rg-form">
          <el-form ref="registform" :model="registform" :rules="rules" label-width="120px">
            <el-form-item label="企业名称" prop="companyName">
              <el-input placeholder="请输入企业名称" v-model="registform.companyName" @blur="yanzheng()">
              </el-input>
            </el-form-item>
            <el-form-item label="企业信用代码" prop="ccode">
              <el-input placeholder="请输入企业信用代码" v-model="registform.ccode" @blur="yanzheng()">
              </el-input>
            </el-form-item>
            <el-form-item label="所属区域" prop="districtId">
              <el-cascader :props="props" v-model="registform.districtId" style="width: 100%;"></el-cascader>
            </el-form-item>
            <el-form-item label="联系人" prop="userName">
              <el-input placeholder="请输入联系人" v-model="registform.userName">
              </el-input>
            </el-form-item>
            <el-form-item label="联系方式" prop="mobile" @blur="yanzheng()">
              <el-input class="rg-input" placeholder="请输入联系方式" v-model="registform.mobile" @input="setLoginname">
              </el-input>
            </el-form-item>
            <el-form-item label="登录账号" prop="loginName" @blur="yanzheng()">
              <el-input autocomplete="off" class="rg-input" placeholder="请输入登录账号" v-model="registform.loginName">
              </el-input>
            </el-form-item>
            <el-form-item label="登录密码" prop="passWord">
              <input type="text" class="hidden" />
              <input type="password" class="hidden" />
              <el-input autocomplete="off" class="rg-input" show-password placeholder="请输入6-18个字符长度密码"
                v-model="registform.passWord">
              </el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="password1">
              <el-input class="rg-input" show-password placeholder="请再次确认密码" v-model="registform.password1">
              </el-input>
            </el-form-item>

            <el-form-item label="企业地址" prop="address">
              <el-input class="rg-input" placeholder="企业地址" v-model="registform.address">
              </el-input>
            </el-form-item>


            <el-button type="primary" @click="onSubmit"
              style="background-color: #0071BA;width: 100%;margin: 0px 0 20px 0;height: 44px;">提交注册
            </el-button>

            <div style="font-size: 16px;color: #0071ba;display: flex;justify-content: space-between;">
              <div><span style="cursor: pointer;" @click="toHome">首页</span></div>
              <div><span style="cursor: pointer;" @click="toLogin">已有账户，去登录 ></span></div>
            </div>

            <div
              style="color: #333;font-size: 14px;cursor: pointer;margin-top: 10px;position: fixed;right: 0;top: 20px;width: 300px;background-color: #fff;padding: 20px;border-radius: 20px;letter-spacing: 1px;">
              <div>
                <span style="font-weight: 800;">注册说明：</span><br />
                1、在双控云、智能隐患排查管控平台、智慧职卫云平台有账号的用户，请直接通知客服开通该服务即可，无需注册。<br />
                2、企业在以上三个平台有账号的，请联系管理员，开通账号并开启该服务。
              </div>
              <div>
                <div style="margin-top: 20px;"><span style="font-weight: 800;">客服：</span></div>
                电话：13137703753<br />
                微信：<img src="@/assets/images/kfwx.jpg" style="height: 160px;"/>
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  let id = 0;
  export default {
    name: 'Register',
    data() {
      var validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('联系方式不能为空！'));
        } else if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
          callback(new Error('联系方式有误，请重新输入！'));
        } else {
          callback();
        }
      };
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('密码不能为空！'));
        } else {
          if (this.registform.password1 !== '') {
            this.$refs.registform.validateField('password1');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('确认密码不能为空！'));
        } else if (value !== this.registform.passWord) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      var $this = this;

      return {
        registform: {},
        props: {
          lazy: true,
          checkStrictly: true,
          lazyLoad(node, resolve) {
            const {
              level,
              value
            } = node;
            var loadUrl = '/system/district/tree2.htm'
            if (value) {
              loadUrl += '?parentId=' + value;
              $this.$axios.get(loadUrl).then(res => {
                var data = res.data;
                const nodes = data.map(item => ({
                  value: item.id,
                  label: item.text,
                  leaf: !item.isParent
                }));
                resolve(nodes);
              })
            } else {
              var data = [{
                text: '河南省',
                id: '22bbafbbf2cf4203a26f3f9ddc6e2f78',
                isParent: true
              }]
              const nodes = data.map(item => ({
                value: item.id,
                label: item.text,
                leaf: !item.isParent
              }));
              resolve(nodes);
            }

          },
        },
        rules: {
          companyName: [{
            required: true,
            message: '企业名称不能为空',
            trigger: 'blur'
          }],
          ccode: [{
            required: true,
            message: '企业信用代码不能为空',
            trigger: 'blur'
          }],
          itype: [{
            required: true,
            message: '注册类型不能为空',
            trigger: 'blur'
          }],
          userName: [{
            required: true,
            message: '联系人不能为空',
            trigger: 'blur'
          }],
          districtId: [{
            required: true,
            message: '区域不能为空',
            trigger: 'blur'
          }],
          mobile: [{
            required: true,
            message: '联系方式不能为空',
            trigger: 'blur'
          }, {
            validator: validatePhone,
            trigger: 'blur'
          }],
          loginName: [{
            required: true,
            message: '登录账号不能为空',
            trigger: 'blur'
          }],
          passWord: [{
            required: true,
            message: '登录密码不能为空',
            trigger: 'blur'
          }, {
            validator: validatePass,
            trigger: 'blur'
          }],
          password1: [{
            required: true,
            message: '密码确认不能为空',
            trigger: 'blur'
          }, {
            validator: validatePass2,
            trigger: 'blur'
          }],
          address: [{
            required: true,
            message: '企业地址不能为空',
            trigger: 'blur'
          }]
        }
      }
    },
    methods: {
      toHome: function() {
        this.$router.push('/Home')
      },
      onSubmit: function() {
        this.$refs['registform'].validate((valid) => {
          var $this = this;
          if (Array.isArray(this.registform.districtId)) {
            this.registform.districtId = this.registform.districtId[this.registform.districtId.length - 1];
          }
          delete this.registform.password1;
          if (valid) {
            this.$axios.post('/system/register/add.htm', this.$qs.stringify(this.registform)).then(res => {
              var data = res.data;
              if (data.stat == '1') {
                this.$message({
                  message: '注册成功，即将跳转登录页面！',
                  type: 'success',
                  onClose: function() {
                    $this.$router.push('/Login');
                  }
                });
              } else {
                this.$message({
                  message: data.message,
                  type: 'error',
                  offset: 250
                });
              }
            })
          } else {
            return false;
          }
        });
      },
      // 跳转登录页面
      toLogin: function() {
        this.$router.push('/Login');
      },
      // 联系方式改变  登录账号也改变
      setLoginname: function(val) {
        this.$set(this.registform, 'loginName', val)
      },
      yanzheng: function() {
        if (Array.isArray(this.registform.districtId)) {
          this.registform.districtId = this.registform.districtId[this.registform.districtId.length - 1];
        }
        delete this.registform.password1;
        this.$axios.post('/system/register/checkName.htm', this.$qs.stringify(this.registform)).then(res => {
          var data = res.data;
          if (data.stat == '1') {} else {
            this.$message({
              message: data.message,
              type: 'error',
              offset: 250
            });
          }
        })
      }
    },
    created: function() {
      this.registform = {
        sid: '16',
        companyName: '',
        mobile: '',
        ccode: '',
        loginName: '',
        passWord: '',
        password1: '',
        itype: '1',
        districtId: '',
        address: '',
        userName: '',
        registerflag: '1'
      };
    }
  }
</script>

<style>
  .all-regiv {
    width: 100vw;
    height: 100vh;
    overflow-x: hidden;
    background-color: #0071BA;
  }

  .rg-btbg {
    width: 100vw;
    height: 100%;
    overflow-x: hidden;
    background: url(../assets/images/ldbg.png) 0 100% no-repeat;
    background-size: 100% 22vh;
  }

  .hidden {
    width: 0;
    height: 0;
    border-width: 0 !important;
    position: absolute;
  }

  .register {
    width: 815px;
    margin: 30px auto 50px;
    background: #fff;
    border-radius: 10px;
    padding-bottom: 20px;
  }

  .rg-herder {
    height: 94px;
    border-radius: 10px 10px 0 0;
    color: #333;
    padding-top: 10px;
  }

  .rg-form {
    width: 633px;
    margin: 10px auto;
  }

  .rg-input .el-input-group__prepend {
    width: 80px;
    text-align: left;
    background-color: #fff;
    height: 41px;
    color: #333333;
  }

  .all-regiv .el-form-item {
    opacity: 1;
    border: 1px solid #d9d9d9;
    border-radius: 3px;
    line-height: 44px;
    width: 633px;
  }

  .all-regiv .el-form-item--medium .el-form-item__label {
    line-height: 44px;
  }

  .all-regiv .el-input__inner {
    border-left: 0;
    height: 43px !important;
    border: none;
  }

  .rg-input .el-cascader .el-input .el-input__inner {
    height: 43px !important;
    border-radius: 0 4px 4px 0;
    border: none;
  }

  input.el-input__inner::-webkit-input-placeholder {
    /* placeholder颜色  */
    color: #aab2bd;
    /* placeholder字体大小  */
    font-size: 14px;
  }

  .rg-input .el-input-group--append .el-select .el-input.is-focus .el-input__inner,
  .el-input-group--prepend .el-select .el-input.is-focus .el-input__inner {
    border-color: #0071BA;
  }

  .all-regiv .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
    display: inline-block;
  }

  .login-bt-bg {}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue